import { useState, type ReactNode } from 'react'
import { View } from 'react-native'
import Page from '@shell/Page'
import Typography from '@ui/typography'
import Slider from '@ui/components/Slider'
import { usePriceFormatter } from 'hooks/useCurrency'

const Section = ({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) => (
  <View className="gap-6">
    <Typography variant="XS" className="uppercase text-black/25">
      {title}
    </Typography>
    {children}
  </View>
)

const currencyMin = 207.5
const currencyMax = 415
const currencyMid = 311.25
const steppedSteps = 10

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {}

export default function DevSliderPage() {
  const formatter = usePriceFormatter()
  const [percentageValue, setPercentageValue] = useState(87)
  const [steppedValue, setSteppedValue] = useState(87)
  const [currencyValue, setCurrencyValue] = useState(currencyMid)
  const [fullValue, setFullValue] = useState(100)
  const [errorValue, setErrorValue] = useState(95)

  const formatPrice = (value: number) => formatter.format(value)

  return (
    <Page stage="dev">
      <View className="gap-12 p-16">
        <Section title="Default">
          <Slider
            min={0}
            max={100}
            step={1}
            value={percentageValue}
            onChange={setPercentageValue}
          />
        </Section>

        <Section title="Stepped">
          <Slider
            min={0}
            max={100}
            step={1}
            steps={steppedSteps}
            variant="stepped"
            value={steppedValue}
            onChange={setSteppedValue}
          />
        </Section>

        <Section title="Side Buttons">
          <Slider
            min={currencyMin}
            max={currencyMax}
            minPercentage={50}
            maxPercentage={100}
            step={1}
            value={currencyValue}
            buttonStart={formatPrice(currencyMin)}
            buttonEnd={formatPrice(currencyMax)}
            showPercentageLabel={false}
            onChange={setCurrencyValue}
          />
        </Section>

        <Section title="Full">
          <Slider
            min={0}
            max={100}
            step={1}
            value={fullValue}
            onChange={setFullValue}
          />
        </Section>

        <Section title="Disabled">
          <Slider
            min={0}
            max={100}
            step={1}
            value={87}
            disabled
            onChange={noop}
          />
        </Section>

        <Section title="Disabled Side Buttons">
          <Slider
            min={currencyMin}
            max={currencyMax}
            minPercentage={50}
            maxPercentage={100}
            step={1}
            value={currencyMid}
            buttonStart={formatPrice(currencyMin)}
            buttonEnd={formatPrice(currencyMax)}
            showPercentageLabel={false}
            disabled
            onChange={noop}
          />
        </Section>

        <Section title="Error">
          <Slider
            min={0}
            max={100}
            step={1}
            value={errorValue}
            hasError
            onChange={setErrorValue}
          />
        </Section>
      </View>
    </Page>
  )
}
